import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import clsx from 'clsx';
import {
  megaMenuMetaobjects,
  megaMenuBannerMetaobjects,
} from '../utils/storefront/queries';
import Storefront from '../utils/storefront';
import {
  formatMegaMenus,
  formatMegaMenusBanners,
} from '../utils/storefront/format-resource';
import Image from '../utils/image';

const SubMenuItems = ({ menu }) => {
  const neededMenus = menu.map((m, index) => ({
    title: m.title,
    url: m.url,
    index,
  }));
  const neededMenusBanners = menu.filter((m) => m.title.includes('#banner'));
  const storefront = new Storefront();
  const [megaMenus, setMegaMenus] = useState(null);
  const [megaMenusBanners, setMegaMenusBanners] = useState(null);
  const [columnCount, setColumnCount] = useState(0);
  useEffect(() => {
    const getMegaMenus = async () => {
      try {
        const response = await storefront.request({
          query: megaMenuMetaobjects,
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenus = formatMegaMenus(response, neededMenus);

        setMegaMenus(formattedMegaMenus);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    const getMegaMenusBanners = async () => {
      try {
        const response = await storefront.request({
          query: megaMenuBannerMetaobjects,
          variables: {
            countryCode: window.TMW.localization.countryCode,
            languageCode: window.TMW.localization.languageCode,
          },
        });

        const formattedMegaMenusBanners = formatMegaMenusBanners(
          response,
          neededMenusBanners,
        );

        setMegaMenusBanners(formattedMegaMenusBanners);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    getMegaMenus();
    getMegaMenusBanners();
  }, [menu]);

  useEffect(() => {
    if (megaMenus && megaMenusBanners) {
      setColumnCount(megaMenus.length);
    }
  }, [megaMenus, megaMenusBanners]);

  return (
    <>
      <div className="flex-auto flex items-start justify-start gap-8">
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => (
            <div key={menuList.handle} className="flex-[0_1_200px]" style={{order: menuList.index}}>
              <p className="font-13-bold mb-2.5 text-black">
                {menuList.handle}
              </p>
              <ul>
                {menuList.links.length > 0 &&
                  menuList.links.map((link) => (
                    <li key={link.label} className="mb-2">
                      <a href={link.url} className="font-13 text-charcoal">
                        {link.label}
                      </a>
                    </li>
                  ))}
                {menuList.url && (
                  <li className="mb-2">
                    <a href={menuList.url} className="font-13 text-charcoal underline">
                      {window.TMW?.Strings?.header?.shopAll}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          ))}
      </div>
      <div className="flex items-start justify-end gap-5">
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div
              key={banner.title}
              className={clsx(
                'min-w-[200px] text-center',
                columnCount > 5 ? 'max-w-[200px]' : 'max-w-[327px]',
              )}
            >
              {banner.url && (
                <a
                  href={banner.url}
                  className="mb-2.5 block link-unstyled"
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  <Image
                    src={banner.image}
                    srcWidths={{
                      sm: 640,
                      md: 768,
                      lg: 1024,
                      xl: 1280,
                      '2xl': 1536,
                    }}
                  />
                </a>
              )}
              {!banner.url && (
                <Image
                  src={banner.image}
                  classes="mb-2.5"
                  srcWidths={{
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1280,
                    '2xl': 1536,
                  }}
                />
              )}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className="font-13 text-black underline block w-fit mx-auto"
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p className="font-13 text-black block w-fit mx-auto">
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default SubMenuItems;
